import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=3fb20b7a&scoped=true"
import script from "./privacy.vue?vue&type=script&lang=js"
export * from "./privacy.vue?vue&type=script&lang=js"
import style0 from "./privacy.vue?vue&type=style&index=0&id=3fb20b7a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb20b7a",
  null
  
)

export default component.exports